import React, {useContext, useState} from "react";
import Button from "@common/Button";
import ButtonSelect from "@common/ButtonSelect";
import CircularLoader from "@common/CircularLoader";
import {BrandContext} from "@context/BrandContext";
import ButtonsGroup from "@common/ButtonsGroup";
import Card, {CARD} from "@common/Card";

const DashboardWidget = props => {
    const {title, className, headerObjects, headerActions, highlight, children, isLoading = false} = props;
    const brandConfig = useContext(BrandContext);

    const headerComponents = {
        Button: Button,
        ButtonSelect: ButtonSelect
    }

    return (
        <div className={'ch-dashboard-blk' + (highlight ? ' ch-dashboard-highlight' : '') + (className ? ' ' + className : '')}>
            <Card padding={CARD.PADDING.EXTRA_SMALL} boxRadius={CARD.RADIUS.EXTRA_SMALL} className={'ch-dashboard-blk-inner'}>
                <div className={'ch-dashboard-blk-title'}>
                    <div className={'ch-dashboard-blk-title-main'}>{title}</div>
                    {headerObjects && headerObjects.length > 0 &&
                        <ButtonsGroup>
                            {headerObjects.map((headerObj, index) => {
                                const HeaderComponent = headerComponents[headerObj.componentName];
                                return <HeaderComponent key={index} {...headerObj.otherProps} />
                            })}
                        </ButtonsGroup>
                    }
                    {headerActions}
                </div>
                <div className={'ch-dashboard-blk-body-wrap'}>
                    {isLoading &&
                        <div className="ch-dashboard-blk-body">
                            <CircularLoader pageCentered={false}/>
                        </div>
                    }
                    {!isLoading &&
                        <>{children}</>
                    }
                </div>
            </Card>
        </div>
    )
}

export default DashboardWidget;